import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["static", "edit"]

    connect() {
        console.log("Forecast Demand controller connected")
    }

    showEdit(event) {
        if (event) event.preventDefault()
        this.staticTarget.classList.add("hidden")
        this.editTarget.classList.remove("hidden")
    }

    showStatic(event) {
        if (event) event.preventDefault()
        this.editTarget.classList.add("hidden")
        this.staticTarget.classList.remove("hidden")
    }
}
